import { BooleanInput, required, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={4}
      sx={{ ...settings.style.shadowBox, padding: ".5rem", justifyContent: "center", paddingRight: "3rem" }}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameBg"
          label="Име на български"
          fullWidth
          validate={required()}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameEn"
          label="Име на английски"
          fullWidth
          validate={required()}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
      >
        <BooleanInput
          label="Видима в кандидатстудентски кампании"
          source="visibleInCandidateCampaigns"
          defaultValue={true}
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
